
import AboutUs from "../Pages/mainPage/About/AboutUs";
import ContactUs from "../Pages/mainPage/ContactUs";
import Home from "../Pages/mainPage/Home/Home";
import PrivacyPolicy from "../Pages/mainPage/PrivacyPolicy";
import E_Form from "../Pages/mainPage/Products/e-Form/E_Form";
import EAM from "../Pages/mainPage/Products/EAM/EAM";
import IPB from "../Pages/mainPage/Products/IPB/IPB";
import OJT from "../Pages/mainPage/Products/OJT/OJT";
import PTW from "../Pages/mainPage/Products/PTW/PTW";
import SafetyWalk from "../Pages/mainPage/Products/SafetyWalk/SafetyWalk";
import Service from "../Pages/mainPage/Service/Service";
import Terms from "../Pages/mainPage/Terms";

export const routerLink = [
  {
    path: "/",
    component: Home,
    // module: "notauthenticate",
  },
  {
    path: "/aboutus",
    component: AboutUs,
    // module: "notauthenticate",
  },
  {
    path: "/products/safetywalk",
    component: SafetyWalk,
    // module: "notauthenticate",
  },
  {
    path: "/products/e_form",
    component: E_Form,
    // module: "notauthenticate",
  },
  {
    path: "/products/ptw",
    component: PTW,
    // module: "notauthenticate",
  },
  {
    path: "/products/eam",
    component: EAM,
    // module: "notauthenticate",
  },
  {
    path: "/products/ojt",
    component: OJT,
    // module: "notauthenticate",
  },
  {
    path: "/products/ipb",
    component: IPB,
    // module: "notauthenticate",
  },
  {
    path: "/services",
    component: Service,
    // module: "notauthenticate",
  },
  {
    path: "/contactus",
    component: ContactUs,
    // module: "notauthenticate",
  },
];

export const policyRouteLink=[
  {
    path: "/policy",
    component: PrivacyPolicy,
    // module: "notauthenticate",
  }, 
  {
    path: "/terms",
    component: Terms,
    // module: "notauthenticate",
  }, 
]
